import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CommunityLayout from './layout/CommunityLayout';
import TimelinePage from './pages/TimelinePage';
import ComposePage from './pages/ComposePage';
import TopicExplorerPage from './pages/TopicExplorerPage';
import NotificationsPage from './pages/NotificationsPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import PostDetailPage from './pages/PostDetailPage';
import SavedPostsPage from './pages/SavedPostsPage';
import UserProfilePage from './pages/UserProfilePage';
import DirectMessagesPage from './pages/DirectMessagesPage';

const CommunityApp: React.FC = () => {
  return (
    <Routes>
      <Route element={<CommunityLayout />}>
        <Route index element={<TimelinePage initialMode="for_you" />} />
        <Route path="topics" element={<TopicExplorerPage />} />
        <Route path="topics/:topicId" element={<TimelinePage initialMode="for_you" />} />
        <Route path="following" element={<TimelinePage initialMode="following" />} />
        <Route path="latest" element={<TimelinePage initialMode="latest" />} />
        <Route path="notifications" element={<NotificationsPage />} />
  <Route path="messages" element={<DirectMessagesPage />} />
  <Route path="messages/:threadId" element={<DirectMessagesPage />} />
        <Route path="saved" element={<SavedPostsPage />} />
        <Route path="profile" element={<ProfilePage />} />
  <Route path="users/:authorId" element={<UserProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="compose" element={<ComposePage />} />
        <Route path="status/:postId" element={<PostDetailPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Route>
    </Routes>
  );
};

export default CommunityApp;
